import React from 'react';

const MarkAsUnRead = ({ width = 20, height = 20, color = '#424242', ...rest }, ref) => {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <path
        d="M18.3334 8.33325C18.3488 8.93914 18.3334 9.21178 18.3334 9.99992C18.3334 13.1426 18.3334 14.714 17.3571 15.6903C16.3808 16.6666 14.8094 16.6666 11.6667 16.6666H8.33341C5.19072 16.6666 3.61937 16.6666 2.64306 15.6903C1.66675 14.714 1.66675 13.1426 1.66675 9.99992C1.66675 6.85722 1.66675 5.28587 2.64306 4.30956C3.61937 3.33325 5.19072 3.33325 8.33341 3.33325H10.8334"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M5 6.66675L6.79908 8.16598C8.32961 9.44142 9.09488 10.0791 10 10.0791C10.9051 10.0791 11.6704 9.44142 13.2009 8.16598"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <circle cx="15.8333" cy="4.16675" r="2.5" stroke={color} strokeWidth="1.25" />
    </svg>
  );
};

export default React.forwardRef(MarkAsUnRead);
